import { useState } from "react";
import { AlertTriangle } from "lucide-react";
import { Button, HStack, Text } from "../ui";
import { useTranslation } from "react-i18next";
import { useAuth } from "@/contexts/AuthContext";

const PasswordResetNotification = () => {
  const { t } = useTranslation();
  const { user: me } = useAuth();
  const [isPasswordResetNotificationDismissed, setIsPasswordResetNotificationDismissed] = useState<boolean>(false);

  if (!me?.resetRequestedAt || isPasswordResetNotificationDismissed) return null;

  return (
    <div className="absolute inset-0 bg-gray-900/50 flex items-center justify-center z-50 p-4 rounded-2xl">
      <div className="bg-white rounded-lg shadow-xl max-w-md w-full p-6 border border-amber-200">
        <HStack className='justify-between items-center mb-4 text-gray-900'>
          <h3 className="text-md sm:text-lg font-semibold">
            {t('secure.passwordResetNotification.title')}
          </h3>
          <AlertTriangle className="size-6" />
        </HStack>
        <Text className="text-gray-700 mb-2">
          {t('secure.passwordResetNotification.message')}
        </Text>
        <Text className='text-gray-700 mb-4'>
          {t('secure.passwordResetNotification.subMessage')}
        </Text>
        <Button
          onClick={() => setIsPasswordResetNotificationDismissed(true)}
          className="w-full"
        >
          {t('secure.passwordResetNotification.dismiss')}
        </Button>
      </div>
    </div>
  )
};

export default PasswordResetNotification;